import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BackButtonComponent, InvalidFieldComponent, LogoFacilityComponent } from 'src/app/shared/components';
import { LoginFormComponent } from 'src/app/shared/components/login-form/login-form.component';
import { MatStrokedButtonBorderDirective, ScrollTopDirective } from 'src/app/shared/directives';
import { SanitizerPipe } from 'src/app/shared/pipes';
import { LoginMaterialModule } from './login-material-modules.module';
import { SignInComponent } from './login.component';

@NgModule({
    imports: [
        CommonModule,
        LogoFacilityComponent,
        ReactiveFormsModule,
        FormsModule,
        BackButtonComponent,
        MatStrokedButtonBorderDirective,
        LoginMaterialModule,
        InvalidFieldComponent,
        SanitizerPipe,
        ScrollTopDirective,
        LoginFormComponent,
    ],
    declarations: [SignInComponent],
    exports: [SignInComponent],
})
export class LoginModule {}
